import { render, staticRenderFns } from "./FilesApp.vue?vue&type=template&id=d3308b8a"
import script from "./FilesApp.vue?vue&type=script&lang=ts"
export * from "./FilesApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports